import classNames from 'classnames';
import { LANGUAGE_MAP } from 'constant/language';
import {
  ContractLang,
  ContractPrintProduct,
  ContractStyleType,
} from '../utils';
import useBrandList from 'commons/hooks/use-brand-list';

const ProductTable = ({
  productList,
  styleType,
  contractLang,
  currencySymbol,
  showId,
  showPrice,
}: {
  productList: ContractPrintProduct[];
  styleType: ContractStyleType;
  contractLang: ContractLang;
  currencySymbol: string;
  showId: boolean;
  showPrice: boolean;
}) => {
  const { SourceBrandList } = useBrandList();

  return (
    <table className="flex-1">
      <thead>
        <tr
          className={classNames(
            styleType === 'white'
              ? 'bg-white text-black'
              : 'bg-black text-white',
          )}
          style={{ printColorAdjust: 'exact' }}
        >
          <th className="p-2 w-10 font-normal"></th>
          <th className="p-2 w-20 font-normal">
            {
              {
                [LANGUAGE_MAP.EN]: 'Brand',
                [LANGUAGE_MAP.JA]: 'ブランド',
                [LANGUAGE_MAP.ZH_CN]: '品牌',
                [LANGUAGE_MAP.FR]: 'Marque',
              }[contractLang]
            }
          </th>
          <th className="p-2 font-normal">
            {
              {
                [LANGUAGE_MAP.EN]: 'Description',
                [LANGUAGE_MAP.JA]: '商品名',
                [LANGUAGE_MAP.ZH_CN]: '商品名',
                [LANGUAGE_MAP.FR]: 'Description',
              }[contractLang]
            }
          </th>
          {showPrice && (
            <th className="p-2 w-28 font-normal">
              {
                {
                  [LANGUAGE_MAP.EN]: 'Cost',
                  [LANGUAGE_MAP.JA]: '金額(税込)',
                  [LANGUAGE_MAP.ZH_CN]: '金额',
                  [LANGUAGE_MAP.FR]: 'Coût',
                }[contractLang]
              }
            </th>
          )}
        </tr>
      </thead>
      <tbody>
        {productList.map((product, i) => (
          <tr className="h-4" key={i}>
            <td className="px-2 py-1">{i + 1}</td>
            <td className="px-2 py-1">
              {
                {
                  [LANGUAGE_MAP.EN]:
                    SourceBrandList.find((dd) => dd.value === product.brandName)
                      ?.nameEn || SourceBrandList[0].nameEn,
                  [LANGUAGE_MAP.JA]:
                    SourceBrandList.find((dd) => dd.value === product.brandName)
                      ?.nameJa || SourceBrandList[0].nameJa,
                  [LANGUAGE_MAP.ZH_CN]:
                    SourceBrandList.find((dd) => dd.value === product.brandName)
                      ?.nameZh || SourceBrandList[0].nameZh,
                  [LANGUAGE_MAP.FR]:
                    SourceBrandList.find((dd) => dd.value === product.brandName)
                      ?.nameEn || SourceBrandList[0].nameEn,
                }[contractLang]
              }
            </td>
            <td className="px-2 py-1">
              {showId && <>{product.id}:</>}
              {product.name}
              {!!product.guestRemark ? (
                <>
                  <div className="border-b" />
                  {product.guestRemark}
                </>
              ) : null}
            </td>

            {showPrice && (
              <td className="px-2 py-1 text-right">
                {currencySymbol + ' ' + Number(product.price).toLocaleString()}
              </td>
            )}
          </tr>
        ))}
        {Array.from({ length: 20 - productList.length }).map((_, index) => {
          return (
            <tr className="h-4" key={index}>
              <td className="px-2 py-1"></td>
              <td className="px-2 py-1"></td>
              <td className="px-2 py-1"></td>
              {showPrice && <td className="px-2 py-1"></td>}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default ProductTable;
